<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GxqxIy/tc-custom/9781590209585.jpg?1738478986226" alt="This image is the cover for the book Hotel Savoy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hotel Savoy
      </h1>
      <p class="bookDescription body article font2">
        <b>A POW meets other survivors of World War I in a Polish hotel in this acclaimed classic novel by the author of <i>The Radetzky March</i>.</b><br/><br/>Still bearing the scars from gulag experiences, a freed POW traverses Russia to arrive at the Polish town of Lodz. In its massive Hotel Savoy, he meets a surreal cast of characters, each eagerly awaiting the return from America of a rich man named Bloomfield. Like Europe itself at the time, the hotel is the stage upon which characters follow fate to its tragic destination . . . <br/><br/><b>Praise for <i>Hotel Savoy</i></b><br/><br/><b>“Superb Roth: witty, elegant, invariably honing in on the point where history trickles down to the level of the individual character and turns into fate.” —<i>The Nation</i></b><br/><br/><b>“Roth’s considerable gift lay in sketching myriad personal convulsions in that time of conflagration.” —<i>Publishers Weekly</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joseph Roth
      </h2>
      
      <p class="authorDescription body article">Joseph Roth was born in 1894 in a small Galician town on the eastern borders of the Hapsburg Empire. After serving in the Austro-Hungarian army from 1916 to 1918, he worked as a journalist in Vienna and in Berlin. He died in Paris in 1939, leaving behind thirteen novels as well as many stories and essays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Overlook Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7fd487d1